let overlay;

function getZoomSource(image) {
  const parent = image.closest('.product__media');
  return parent?.dataset.zoomSrc || image.currentSrc || image.src;
}

function getZoomWidth(image) {
  const parent = image.closest('.product__media');
  const width = parseInt(parent?.dataset.zoomWidth, 10);
  if (width) return width;

  try {
    const fromUrl = parseInt(new URL(getZoomSource(image)).searchParams.get('width'), 10);
    if (fromUrl) return fromUrl;
  } catch (e) {
    /* ignore */
  }

  return image.naturalWidth || image.clientWidth;
}

function getZoomRatio(image, preferredMax = 3) {
  const displayWidth = image.clientWidth;
  const hiResWidth = getZoomWidth(image);
  if (!displayWidth || !hiResWidth) return Math.min(preferredMax, 2);

  const maxWithoutUpscale = hiResWidth / displayWidth;
  return Math.min(preferredMax, maxWithoutUpscale);
}

function createOverlay(image, hiResSrc) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', hiResSrc);
  overlay = document.createElement('div');
  prepareOverlay(overlay, hiResSrc);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, srcUrl) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${srcUrl}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.clientHeight / image.clientWidth;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const hiResSrc = getZoomSource(image);
  const overlayEl = createOverlay(image, hiResSrc);
  overlayEl.onclick = () => overlayEl.remove();
  overlayEl.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlayEl.onmouseleave = () => overlayEl.remove();
}

function enableZoomOnHover(preferredMax = 3) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      const zoomRatio = getZoomRatio(image, preferredMax);
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(3);
